<template>
    <div>
        <h1>{{ transl["STR_TITLE_DEVICES"] }}</h1>


        <div class="developer" v-if="this.$store.getters.developer">
            <b>Entwickler Ausgabe:</b>
            <pre v-html="this.$store.getters.cyclers"></pre>
        </div>
<!--
        <div class="info warning" style="background-color: #ff4800; padding: 15px;margin-bottom: 10px;" v-if="this.$store.getters.cyclers.filter(d => d.state == 99).length !== 0">
            Bitte wenden Sie sich an unseren Support um die <b>Firmware</b> der unten angef&uuml;hrten Ger&auml;te zu aktualisieren.
        </div>
-->


        <table border=0>
            <thead>
                <th width="150">{{ transl["STR_SERIAL"] }}</th>
                <th width="200">{{ transl["STR_DEV_CUSTNAME"] }}</th>
                <th width="100">{{ transl["STR_ONLINE"] }}</th>
                <th width="200">{{ transl["STR_STATE"] }}</th>
                <th width="140">{{ transl["STR_ACTIONS"] }}</th>
                <th width="100" v-if="curves">AnyDesk</th>
            </thead>
            <tbody>
                <tr v-for="d in this.$store.getters.cyclers">
                    <td>
                        {{ d.serial }}
                    </td>
                    <td>
                        <div class="devicenameedit">
                        <div class="devicename">{{ d.name }}</div>
                        <div title="Gerätenamen ändern" class="deviceedit" v-on:click="SetDeviceName(d.serial)"><i class="fas fa-pencil-alt"></i></div>
                        </div>
                    </td>                    
                    <td>{{ d.online ? transl["STR_YES"] : transl["STR_NO"] }}</td>
                    <td>
                        <span v-if="!d.cmdpend">
                            <span v-if="d.online">
                                <span v-if="d.state == 99">Firware Update erforderlich</span>
                                <span v-else>{{ d.state == 1 ? transl["STR_BUSY"] : transl["STR_AVAIL"] }}</span></span>
                            <span v-else>
                                {{ transl["STR_OFFLINE"] }}
                            </span>
                        </span>
                        <span v-else>
                            Wartet auf Best&auml;tigung.
                        </span>
                    </td>
                    <td>
                        <a style="cursor: pointer;" v-on:click="ShowTestsForDevice(d.serial)">
                            {{ transl["STR_SHOW_TESTS"] }}
                        </a>
                    </td>
                    <td v-if="curves">
                        <div v-on:click="StartAnyDesk(d)" class="anydesk">AnyDesk</div>
                    </td>
                </tr>
                <tr v-if="!this.$store.getters.cyclers.length">
                    <td colspan="5">Sie verf&uuml;gen aktuell &uuml;ber keine PCR Ger&auml;te.</td>
                </tr>
            </tbody>
        </table>
        <div class="magic-button" v-on:click="addCycler()">
            {{ transl["STR_ADD_DEVICE"] }}
        </div>
    </div>
</template>
<script>
export default ({
    props: [ 'devices', 'curves', 'transl' ],
    data() {
        return { nicks: [] }
    },
    filters: {
        timeFilter(a) {
            return Math.round((Date.now()/1000)-a);
        }
    },
    mounted() {
        this.loadNicks();
    },
    methods: {
        StartAnyDesk(c) {
            top.location.href="anydesk://"+c.anydesk;
        },
        SendCommand(cycler, command) {
            if(confirm("Möchten Sie das Kommando '"+command+"' wirklich ausführen?")) {
                this.$store.dispatch("SendDeviceCommand", {
                    device: cycler.cyclerId,
                    command: command,
                })
            }
        },
        ShowTestsForDevice(d) {
            this.$router.push({
                name: 'ShowTestsForDevice',
                params: {
                    device: d,
                }
            })
        },
        loadNicks() {
            this.nicks = [];
            this.$store.getters.cyclers.forEach((c) => {
                var nickname = localStorage.getItem(c.serial);
                if(nickname) {
                    this.nicks.push({
                        serial: c.serial,
                        nick: nickname,
                    })
                }
            })
        },
        nickname(serial) {
            var find = this.nicks.find(e => e.serial == serial);
            if(find) {
                return find.nick;
            } else {
                return serial;
            }
        },
        SetDeviceName(serial) {
            var nn = prompt("Bitte geben Sie die neue Bezeichnung für das Gerät ein:")
            if(nn) {
                this.$store.dispatch("SetDeviceName", {
                    serial: serial,
                    name: nn,
                })
            }
        },
        addCycler() {
            this.$router.push({
                name: 'Pairing',
            })
        }
    }
})
</script>
